import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { AppService } from 'src/app/services/app.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { ServicesStateService } from 'src/app/services/services-state.service';
import { IService } from 'src/app/services/client.service';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-services',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, MatChipsModule,MatIconModule, MatDividerModule,MatProgressSpinnerModule],
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  services: IService[] = [];
  selectedServices: Set<string> = new Set();
  loadServices=false;
  isLoading: boolean = true;

  constructor(
    private appService: AppService,
    private sessionStorageService: SessionStorageService,
    private servicesStateService: ServicesStateService
  ) { }

  ngOnInit(): void {
    this.loadServices=false;
    const sessionDataString = this.sessionStorageService.getSessionItem('oabAppSessionData');
    const sessionData = sessionDataString ? JSON.parse(sessionDataString) : null;

    let departmentCode = '';
    let make = '';

    if (sessionData?.vehicleInfo) {
      departmentCode = sessionData.vehicleInfo.type;
      make = sessionData.vehicleInfo.make;
    }
    this.loadSelectedServicesFromSession(sessionData);
    this.updateServicesState();

    this.appService.getServices({
      department: departmentCode,
      make: make
    })
      .subscribe({
        next: (services) => {
          this.services = services.filter(
            service => service.department === departmentCode
          );
          this.updateServicesState();
          this.isLoading=false;
          this.loadServices = true;
        },
        error: (err) => {
          this.appService.handleErrorMessage(err);
          this.loadServices = true;
        }
      });
  }


  toggleService(service: IService): void {
    if (!service.id) return;

    if (this.selectedServices.has(service.id)) {
      this.selectedServices.delete(service.id);
    } else {
      this.selectedServices.add(service.id);
    }

    this.saveSelectedServicesToSession();
    this.updateServicesState();
  }


  removeService(serviceId: string): void {
    this.selectedServices.delete(serviceId);
    this.saveSelectedServicesToSession();
    this.updateServicesState();
  }

  clearAll(): void {
    this.selectedServices.clear();
    this.saveSelectedServicesToSession();
    this.updateServicesState();
  }

  isSelected(service: IService): boolean {
    return !!service.id && this.selectedServices.has(service.id);
  }


  get selectedCount(): number {
    return this.selectedServices.size;
  }

  private loadSelectedServicesFromSession(sessionData: any): void {
    if (sessionData?.appointment?.services && Array.isArray(sessionData.appointment.services)) {
      sessionData.appointment.services.forEach((service: IService) => {
        if (service.id) {
          this.selectedServices.add(service.id);
        }
      });
    }
  }

  private saveSelectedServicesToSession(): void {
    const sessionDataString = this.sessionStorageService.getSessionItem('oabAppSessionData');
    const sessionData = sessionDataString ? JSON.parse(sessionDataString) : {};

    const selectedServiceObjects = this.getSelectedServiceObjects();

    const updatedSessionData = {
      ...sessionData,
      appointment: {
        ...sessionData.appointment,
        services: selectedServiceObjects,
        appointmentDate: null,
        selectedTimeslot: null
      }
    };

    this.sessionStorageService.setSessionItem('oabAppSessionData', JSON.stringify(updatedSessionData));
  }

  private getSelectedServiceObjects(): IService[] {
    return this.services.filter(service => service.id && this.selectedServices.has(service.id));
  }

  private updateServicesState(): void {
    const hasSelectedServices = this.selectedServices.size > 0;
    this.servicesStateService.updateServicesState(hasSelectedServices);
  }
}
